import { gql, useMutation } from "@outschool/ui-apollo";
import { FullCurrentUserFragment } from "./CurrentUserQuery";
import {
  UpdateCurrentUserPublicFundingMutation as UpdateCurrentUserPublicFundingMutationType,
  UpdateCurrentUserPublicFundingMutationVariables,
} from "@outschool/gql-frontend-generated";

export const UpdateCurrentUserPublicFundingMutation = gql`
  mutation UpdateCurrentUserPublicFunding($details: UserDetailsInput) {
    updateCurrentUser(details: $details) {
      ...FullCurrentUserFragment
    }
  }
  ${FullCurrentUserFragment}
`;

export function useUpdateCurrentUserPublicFundingMutation() {
  return useMutation<
    UpdateCurrentUserPublicFundingMutationType,
    UpdateCurrentUserPublicFundingMutationVariables
  >(UpdateCurrentUserPublicFundingMutation);
}
